// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20qsX","content":"styles_content__q1fXI"};